(function() {
  'use strict';
  
  console.log('[Delivery Time Protection] Script loaded');
  
  // 元のfetchを保存
  const originalFetch = window.fetch;
  
  // fetchをオーバーライド
  window.fetch = function(...args) {
    const url = args[0];
    const urlString = typeof url === 'string' ? url : url.toString();
    const options = args[1] || {};
    const method = (options.method || 'GET').toUpperCase();
    
    // POSTリクエストでcart.jsonへのリクエストをチェック
    if (method === 'POST' && urlString.includes('/cart.json')) {
      const body = options.body || '';
      let bodyString = '';
      
      // bodyの形式を判定して文字列に変換
      if (typeof body === 'string') {
        bodyString = body;
      } else if (body instanceof FormData) {
        // FormDataの場合は変換が難しいので、そのまま通す
        return originalFetch.apply(this, args);
      } else if (body instanceof URLSearchParams) {
        bodyString = body.toString();
      } else {
        bodyString = body.toString();
      }
      
      // Delivery Timeの値をチェック
      if (bodyString.includes('attributes%5BDelivery%20Time%5D=')) {
        // URLデコードして値を確認
        const timeMatch = bodyString.match(/attributes%5BDelivery%20Time%5D=([^&]*)/);
        
        if (timeMatch) {
          const encodedValue = timeMatch[1];
          const decodedValue = decodeURIComponent(encodedValue);
          
          // "配送時間の選択"または空文字の場合はブロック
          if (decodedValue === '配送時間の選択' || decodedValue === '' || !decodedValue) {
            console.log('[Delivery Time Protection] Blocked request with invalid delivery time:', decodedValue || '(empty)');
            
            // エラーレスポンスを返す
            return Promise.resolve(new Response(JSON.stringify({
              error: 'Please select a valid delivery time',
              description: '配送時間を選択してください'
            }), {
              status: 400,
              headers: {
                'Content-Type': 'application/json'
              }
            }));
          }
        }
      }
    }
    
    // その他のリクエストは通常通り処理
    return originalFetch.apply(this, args);
  };
  
  // XMLHttpRequestもオーバーライド
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._method = (method || 'GET').toUpperCase();
    this._url = url.toString();
    return originalOpen.call(this, method, url, ...rest);
  };
  
  XMLHttpRequest.prototype.send = function(data) {
    const urlString = this._url || '';
    const httpMethod = this._method || 'GET';
    
    // POSTリクエストでcart.jsonへのリクエストをチェック
    if (httpMethod === 'POST' && urlString.includes('/cart.json')) {
      let bodyString = '';
      
      // dataの形式を判定して文字列に変換
      if (!data) {
        bodyString = '';
      } else if (typeof data === 'string') {
        bodyString = data;
      } else if (data instanceof FormData) {
        // FormDataの場合は変換が難しいので、そのまま通す
        return originalSend.call(this, data);
      } else if (data instanceof URLSearchParams) {
        bodyString = data.toString();
      } else {
        bodyString = data.toString();
      }
      
      // Delivery Timeの値をチェック
      if (bodyString.includes('attributes%5BDelivery%20Time%5D=')) {
        // URLデコードして値を確認
        const timeMatch = bodyString.match(/attributes%5BDelivery%20Time%5D=([^&]*)/);
        
        if (timeMatch) {
          const encodedValue = timeMatch[1];
          const decodedValue = decodeURIComponent(encodedValue);
          
          // "配送時間の選択"または空文字の場合はブロック
          if (decodedValue === '配送時間の選択' || decodedValue === '' || !decodedValue) {
            console.log('[Delivery Time Protection] Blocked XHR request with invalid delivery time:', decodedValue || '(empty)');
            
            // エラーレスポンスを返す
            const self = this;
            setTimeout(() => {
              Object.defineProperty(self, 'readyState', { value: 4, writable: true });
              Object.defineProperty(self, 'status', { value: 400, writable: true });
              Object.defineProperty(self, 'statusText', { value: 'Bad Request', writable: true });
              const errorResponse = JSON.stringify({
                error: 'Please select a valid delivery time',
                description: '配送時間を選択してください'
              });
              Object.defineProperty(self, 'responseText', { value: errorResponse, writable: true });
              Object.defineProperty(self, 'response', { value: errorResponse, writable: true });
              
              if (self.onreadystatechange) {
                self.onreadystatechange();
              }
              if (self.onload) {
                self.onload();
              }
            }, 0);
            return;
          }
        }
      }
    }
    
    // その他のリクエストは通常通り処理
    return originalSend.call(this, data);
  };
  
  console.log('[Delivery Time Protection] Protection active');
})();